import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, formatDay } from "utils/helpers";
import FileView from "components/fileView";
import { LoadingIcon } from "utils/constant";
import ShowUI, { CanShow, LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";
import { updateLegislativeDrafting } from "services/legislativeService";
import { useToast } from "contexts/ToastContext";
import { LEGAL_TRAINING_PROVISION_REQUEST_STATUS, SECTOR_DIRECTIVES_REQUEST_STATUS } from "utils/constantValues";
import HeadRemark from "./headRemark";
import DirectorRemark from "./directorRemark";
import CoordinatorRemark from "./coordinatorRemark";
import ProsecutorRemark from "./prosecutorRemark";
import ActionAvatars from "pages/conductLegalResearch/fragments/actionAvatars";
import PublicFeedback from "./publicFeedback";
import UploadAmendedFile from "./uploadAmendedFile";
import DynamicFormInput from "components/form/form";
import { useAuth } from "contexts/AuthContext";
import { StatusChip } from "components/StatusChip";
import RespondBackForm from "pages/conductLegalResearch/fragments/respondBackform";
import LegislativeRespondBackForm from "./LegislativeResponback";
import { updateLegalAdvisory } from "services/legalAdvisoryService";
import { updateSectorDirective } from "services/sectorDirectives";
import TeamView from "components/team_view";
import EditTeamModal from "pages/conductLegalResearch/fragments/editTeamModal";
import { updateLegalTrainingProvision } from "services/legalTrainingProvision";
import ScheduleTitlePresentationModal from "pages/conductLegalResearch/fragments/scheduleTitlePresentationModal";
import UploadDraftLaw from "./uploadDraftLaw";
import DocumentViewerModal from "components/DocumentViewer";
import DistributeToZone from "./distributeToZone";
import ConfirmationModal from "components/ConfirmationModal1";
import TabNav from "components/TabNav";
import { useTranslation } from "react-i18next";


function LegalTrainingProvisionDetail({ request }: { request: any }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [publicFeedback, setPublicFeedback] = useState(false);
    const [uploadAmend, setUploadAmend] = useState(false);
    const [auditDraft, setAuditDraft] = useState(false);
    const [showDraftHistory, setShowDraftHistory] = useState(false);
    const [edit, setEdit] = useState(false);
    const [formState, setFormState] = useState({ ...request });
    const contextData = useAuth();
    const { showToast } = useToast();
    const [viewTeam, setViewTeam] = useState(false);
    const [isTargetModalOpen, setIsTargetModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDistributeModalOpen, setIsDistributeModalOpen] = useState(false);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [confirmationAction, setConfirmationAction] = useState<string>('');
    const [activeTab, setActiveTab] = useState<string>('');
    const [editTeamModalOpen, setEditTeamModalOpen] = useState(false);

    const handleTargetCloseModal = () => {
        setIsTargetModalOpen(false);
    }
    const handleCloseModal = () => {
        setIsModalOpen(false);
    }
    const handleUploadProposalClick = () => {
    }

    const [isRespondBackFormOpen, setIsRespondBackFormOpen] = useState(false);

    const handleFileChange = (
        file: any,
        fieldName: keyof Pick<
            typeof formState,
            "audit_summary_file"
        >
    ) => {
        setFormState((prev: any) => ({
            ...prev,
            [fieldName]: file,
        }));
    };

    const handleChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        const { name, value } = e.target;
        setFormState((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleRespondBackClick = () => {
        setIsRespondBackFormOpen(!isRespondBackFormOpen);
    }

    const handleAdditionalInfoApprove = async () => {
        setLoading(true);
        const data = new FormData();

        data.append("forward_status", SECTOR_DIRECTIVES_REQUEST_STATUS.forwarded_to_registrar.value);

        try {
            const response = await updateSectorDirective(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("ProposalApprovedSuccess") || "Legal research proposal Approved!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateApproval") || "Failed to update legal research proposal Approval.", "error");
        } finally {
            setLoading(false);
        }
    }

    const handleReject = () => {
    }

    const handleForward = async (froward_status: string) => {
        const data = new FormData();
        if (froward_status === LEGAL_TRAINING_PROVISION_REQUEST_STATUS.training_manual_approved.value) {
            data.append(
                "status",
                froward_status
            );

            try {
                const response = await updateLegalTrainingProvision(formState.id, data);

                setFormState((prev: any) => ({ ...prev, ...response }));
                showToast(t("LegalTrainingRequestForwardedSuccess") || "Legal Training Request Forwarded successfully!", "success");
            } catch (error) {
                console.error("Error submitting request:", error);
                showToast(t("FailedToUpdateLegalTrainingRequest") || "Failed to update Legal Training request.", "error");
            } finally {
                setLoading(false);
            }
            return;
        }

        data.append(
            "forward_status",
            froward_status
        );

        try {
            const response = await updateLegalTrainingProvision(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegalTrainingRequestForwardedSuccess") || "Legal Training Request Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegalTrainingRequest") || "Failed to update Legal Training request.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleAudit = async () => {
        const data = new FormData();
        data.append("audit_summary", formState.audit_summary);
        data.append("audit_summary_file", formState.audit_summary_file);
        data.append("status", SECTOR_DIRECTIVES_REQUEST_STATUS.audit_submitted.value);

        try {
            const response = await updateSectorDirective(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegislativeDraftForwardedSuccess") || "Legislative Draft Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegislativeDraftRequest") || "Failed to update Legislative Draft request.", "error");
        } finally {
            setLoading(false);
            setAuditDraft(false);
        }
    };

    const handlePublish = async () => {
        const data = new FormData();
        data.append("status", SECTOR_DIRECTIVES_REQUEST_STATUS.published.value);
        data.append("forward_status", SECTOR_DIRECTIVES_REQUEST_STATUS.not_forwarded.value);

        try {
            const response = await updateSectorDirective(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegislativeDraftForwardedSuccess") || "Legislative Draft Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegislativeDraftRequest") || "Failed to update Legislative Draft request.", "error");
        } finally {
            setLoading(false);
            setAuditDraft(false);
        }
    };

    const handleDraftApprove = async () => {
        const data = new FormData();
        data.append("status", SECTOR_DIRECTIVES_REQUEST_STATUS.draft_approved.value);
        data.append("forward_status", SECTOR_DIRECTIVES_REQUEST_STATUS.forwarded_to_registrar.value);

        try {
            const response = await updateSectorDirective(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegislativeDraftForwardedSuccess") || "Legislative Draft Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegislativeDraftRequest") || "Failed to update Legislative Draft request.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleFinalApprove = async () => {
        const data = new FormData();
        data.append("status", SECTOR_DIRECTIVES_REQUEST_STATUS.final_approval.value);

        try {
            const response = await updateSectorDirective(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegislativeDraftForwardedSuccess") || "Legislative Draft Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegislativeDraftRequest") || "Failed to update Legislative Draft request.", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { console.log("formState: ", formState) }, [formState]);
    useEffect(() => {
        if (formState?.distributed_zones?.length > 0 && !activeTab) {
            setActiveTab(formState.distributed_zones[0].admin_unit_name);
        }
    }, [formState.distributed_zones, activeTab]);

    // Helper function for method display
    const getMethodDisplay = (method: string) => {
        if (method === "in_person") return t("InPerson") || "In-Person";
        if (method === "online") return t("Online") || "Online";
        if (method === "hybrid") return t("Hybrid") || "Hybrid";
        return method;
    };

    const getRemainingDays = (scheduledDate: string) => {
        if (!scheduledDate) return null;
        const scheduled = new Date(scheduledDate);
        const now = new Date();
        const diffTime = scheduled.getTime() - now.getTime();
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };

    const remainingDays = formState.logistics?.date 
        ? getRemainingDays(formState.logistics.date) 
        : null;

    return (
        <div className="flex-1 bg-gray-100 mx-4 rounded-lg overflow-y-scroll scrollbar-hide">
            <div className="flex flex-col max-w-4xl bg-white rounded-lg shadow-md p-6">
                {/* Header */}
                <div className="flex items-center justify-between pb-4 mb-3">
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={() => navigate("/legal-training-provision")}
                            className="text-gray-600 hover:text-gray-800"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M15 19l-7-7 7-7"
                                />
                            </svg>
                        </button>
                    </div>
                    <h1 className="text-2xl font-semibold text-gray-800 ml-8">
                        {t("RequestForLegalTrainingProvision") || "Request for Legal Training Provision"}
                    </h1>
                    <div className="ml-auto">
                        <StatusChip status={formState.status} />
                        <StatusChip status={formState.forward_status} />
                    </div>
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.registrar_forward_to_coordinator.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div className="ml-auto flex gap-4">
                            <button onClick={() => { setConfirmationAction(LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_coordinator.value); setIsConfirmationModalOpen(true); }} type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                        </div>
                    </ShowUI>
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.coordinator_forward_to_registrar.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div className="flex ml-auto gap-4">
                            <div className="flex gap-4">
                                <button onClick={() => { setConfirmationAction(LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_coordinator.value); setIsConfirmationModalOpen(true); }} type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                            </div>
                            <div className="flex gap-4">
                                <button onClick={() => { setConfirmationAction(SECTOR_DIRECTIVES_REQUEST_STATUS.forwarded_to_registrar.value); setIsConfirmationModalOpen(true); }} type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                            </div>
                        </div>
                    </ShowUI>
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_coordinator_forward_to_prosecutor.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div onClick={() => navigate("/legal-training-provision/internal-request", { state: { request: formState } })} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer ml-auto">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                            </svg>
                        </div>
                    </ShowUI>
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.stakeholder_forward_to_registrar.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div className="flex ml-auto gap-4">
                            <div onClick={() => navigate("/legal-training-provision/request", { state: { request: formState } })} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                </svg>
                            </div>
                            <div className="flex gap-4">
                                <button onClick={() => { setConfirmationAction(SECTOR_DIRECTIVES_REQUEST_STATUS.forwarded_to_registrar.value); setIsConfirmationModalOpen(true); }} type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                            </div>
                        </div>
                    </ShowUI>
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.stakeholder_forward_to_head.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div className="flex ml-auto gap-4">
                            <div onClick={() => navigate("/legal-training-provision/request", { state: { request: formState } })} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                </svg>
                            </div>
                            <div className="flex gap-4">
                                <button onClick={() => { setConfirmationAction(SECTOR_DIRECTIVES_REQUEST_STATUS.forwarded_to_head.value); setIsConfirmationModalOpen(true); }} type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                            </div>
                        </div>
                    </ShowUI>
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.head_forward_to_director.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div className="flex ml-auto gap-4">
                            <ShowUI
                                ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_head_forward_to_director.value}
                                currentStatus={formState.status}
                                forwardStatus={formState.forward_status}
                            >
                                <div onClick={() => setEdit(!edit)} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                    {edit ?
                                        <p>{t("Cancel") || "Cancel"}</p> :
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                        </svg>}
                                </div>
                            </ShowUI>
                            <div className="flex gap-4">
                                <button onClick={() => { setConfirmationAction(formState.status === LEGAL_TRAINING_PROVISION_REQUEST_STATUS.under_review.value ? LEGAL_TRAINING_PROVISION_REQUEST_STATUS.not_forwarded.value : LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_director.value); setIsConfirmationModalOpen(true); }} type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                            </div>
                        </div>
                    </ShowUI>
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.director_forward_to_coordinator.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div className="flex ml-auto gap-4">
                            <div onClick={() => setEdit(!edit)} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                {edit ?
                                    <p>{t("Cancel") || "Cancel"}</p> :
                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                    </svg>}
                            </div>
                            <div className="flex gap-4">
                                <button onClick={() => { setConfirmationAction(formState.status === LEGAL_TRAINING_PROVISION_REQUEST_STATUS.back_to_head.value ? LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_head.value : LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_coordinator.value); setIsConfirmationModalOpen(true); }} type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                            </div>
                        </div>
                    </ShowUI>
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.coordinator_forward_to_prosecutor.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div className="flex ml-auto gap-4">
                            <ShowUI
                                ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_coordinator_forward_to_prosecutor.value}
                                currentStatus={formState.status}
                                forwardStatus={formState.forward_status}
                            >
                                <div onClick={() => setEdit(!edit)} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                    {edit ?
                                        <p>{t("Cancel") || "Cancel"}</p> :
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                        </svg>}
                                </div>
                            </ShowUI>
                            <div className="flex gap-4">
                                <button onClick={() => { setConfirmationAction(formState.status === LEGAL_TRAINING_PROVISION_REQUEST_STATUS.back_to_director.value ? LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_coordinator.value : LEGAL_TRAINING_PROVISION_REQUEST_STATUS.assigned_to_prosecutor.value); setIsConfirmationModalOpen(true); }} type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                            </div>
                        </div>
                    </ShowUI>
<ShowUI
                         ui_key={LEGISLATIVE_DRAFTING_UI_RULES.coordinator_forward_to_head.value}
                         currentStatus={formState.status}
                         forwardStatus={formState.forward_status}
                     >
                         <div className="flex ml-auto gap-4">
                             <div className="flex gap-4">
                                 <button onClick={() => { setConfirmationAction(LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_head.value); setIsConfirmationModalOpen(true); }}
                                     type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                             </div>
                         </div>
                     </ShowUI>
                     <ShowUI
                         ui_key={LEGISLATIVE_DRAFTING_UI_RULES.additional_info_action.value}
                         currentStatus={formState.status}
                         forwardStatus={formState.forward_status}
                     >
                         <div className="flex ml-auto gap-4">
                             <div className="flex gap-4">
                                 <button onClick={() => { setConfirmationAction(formState.status === LEGAL_TRAINING_PROVISION_REQUEST_STATUS.additional_info_responded.value ? LEGAL_TRAINING_PROVISION_REQUEST_STATUS.assigned_to_prosecutor.value : LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_registrar.value); setIsConfirmationModalOpen(true); }} type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                             </div>
                         </div>
                     </ShowUI>
                    {/* Only team leaders (LegalResearchProsecutor with role === "leader") can forward */}
{contextData?.user?.roles?.some((p) => p === "LegalResearchCoordinator") || 
                     (contextData?.user?.roles?.some((p) => p === "LegalResearchProsecutor") && 
                      formState?.prosecutor_assignments?.find((pa: any) => 
                        pa.prosecutor_id === contextData?.user?.user_id && pa.role === "leader"
                      )) ? (
                         <ShowUI
                             ui_key={LEGISLATIVE_DRAFTING_UI_RULES.prosecutor_forward_to_coordinator.value}
                             currentStatus={formState.status}
                             forwardStatus={formState.forward_status}
                         >
                             <div className="flex ml-auto gap-4">
                                 <div className="flex gap-4">
                                     <button onClick={() => { setConfirmationAction(LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_coordinator.value); setIsConfirmationModalOpen(true); }}
                                         type="button" className="bg-[#212121] text-white rounded-lg px-4">{t("Forward") || "Forward"}</button>
                                 </div>
                             </div>
                         </ShowUI>
                     ) : null}
                    <div>
                    </div>
                </div>
                
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.publish.value}
                    currentStatus={formState.status}
                    forwardStatus={formState.forward_status}
                >
                    <div className="flex mb-4">
                        <button onClick={handlePublish} className="p-4 flex-1 bg-[#212121] text-white rounded-lg">{t("BroadcastToPublicWebsite") || "Broadcast to Public Website"}</button>
                    </div>
                </ShowUI>
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.broadcasted.value}
                    currentStatus={formState.status}
                    forwardStatus={formState.forward_status}
                >
                    <div className="flex mb-4">
                        <button className="p-4 flex-1 bg-[#212121] text-white rounded-lg">{t("Broadcasted") || "Broadcasted"}</button>
                    </div>
                </ShowUI>
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.final_approval.value}
                    currentStatus={formState.status}
                    forwardStatus={formState.forward_status}
                >
                    <LegislativeRespondBackForm
                        request={formState}
                        setLegalResearch={setFormState}
                        isOpen={isRespondBackFormOpen}
                        onClose={() => setIsRespondBackFormOpen(false)}
                        forward={SECTOR_DIRECTIVES_REQUEST_STATUS.audit_responded.value}
                    />
                    <div className="flex gap-4">
                        <button onClick={handleRespondBackClick} className="p-4 flex-1 bg-[#D4D4D4] text-[#212121] rounded-lg">{t("RespondBack") || "Respond Back"}</button>
                        <button onClick={handleFinalApprove} className="p-4 flex-1 bg-[#212121] text-white rounded-lg">{t("FinalApproveDraftLaw") || "Final Approve Draft Law"}</button>
                    </div>
                </ShowUI>
                
                <div className="flex-1 overflow-y-scroll scrollbar-hide">
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.forward_darft_to_director.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <LegislativeRespondBackForm
                            request={formState}
                            setLegalResearch={setFormState}
                            isOpen={isRespondBackFormOpen}
                            onClose={() => setIsRespondBackFormOpen(false)}
                            forward={LEGAL_TRAINING_PROVISION_REQUEST_STATUS.team_assigned.value}
                            forwardStatus={LEGAL_TRAINING_PROVISION_REQUEST_STATUS.assigned_to_prosecutor.value}
                            type="training"
                        />
                        <div className="mt-4 pb-8 border-b border-gray-200 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                            <button
                                type="button"
                                className="flex-1 px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                onClick={handleRespondBackClick}
                            >
                                {loading ? (
                                    <div className="flex items-center justify-center">
                                        {LoadingIcon} {t("Submitting") || "Submitting..."}
                                    </div>
                                ) : (
                                    t("RespondBack") || "Respond back"
                                )}
                            </button>
                            <div
onClick={() => { setConfirmationAction(LEGAL_TRAINING_PROVISION_REQUEST_STATUS.forwarded_to_head.value); setIsConfirmationModalOpen(true); }}
                                className="flex-1 text-center cursor-pointer px-6 py-3 rounded-md bg-[#212121] text-white font-semibold hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-600"
                            >
                                {loading ? (
                                    <div className="flex items-center justify-center">
                                        {LoadingIcon} {t("Submitting") || "Submitting..."}
                                    </div>
                                ) : (
                                    t("Approve") || "Approve"
                                )}
                            </div>
                        </div>
                    </ShowUI>
                    
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.forward_darft_to_head.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <LegislativeRespondBackForm
                            request={formState}
                            setLegalResearch={setFormState}
                            isOpen={isRespondBackFormOpen}
                            onClose={() => setIsRespondBackFormOpen(false)}
                            forward={LEGAL_TRAINING_PROVISION_REQUEST_STATUS.team_assigned.value}
                            forwardStatus={LEGAL_TRAINING_PROVISION_REQUEST_STATUS.assigned_to_prosecutor.value}
                            type="training"
                        />
                        <div className="mt-4 pb-8 border-b border-gray-200 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                            <button
                                type="button"
                                className="flex-1 px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                onClick={handleRespondBackClick}
                            >
                                {loading ? (
                                    <div className="flex items-center justify-center">
                                        {LoadingIcon} {t("Submitting") || "Submitting..."}
                                    </div>
                                ) : (
                                    t("RespondBack") || "Respond back"
                                )}
                            </button>
                            <div
                                onClick={() => { setConfirmationAction('draft_approve'); setIsConfirmationModalOpen(true); }}
                                className="flex-1 text-center cursor-pointer px-6 py-3 rounded-md bg-[#212121] text-white font-semibold hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-600"
                            >
                                {loading ? (
                                    <div className="flex items-center justify-center">
                                        {LoadingIcon} {t("Submitting") || "Submitting..."}
                                    </div>
                                ) : (
                                    t("Approve") || "Approve"
                                )}
                            </div>
                        </div>
                    </ShowUI>
                    
                    {formState.logistics && (
                        <div className="bg-white border border-green-700 rounded-xl p-5 mb-6 shadow-sm hover:shadow-md transition-all duration-200">
                            <div className="flex items-center justify-between mb-4 border-b border-gray-50 pb-3">
                                <div className="flex items-center gap-3">
                                    <div className="p-2 bg-blue-50 rounded-lg">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                            <line x1="16" y1="2" x2="16" y2="6"></line>
                                            <line x1="8" y1="2" x2="8" y2="6"></line>
                                            <line x1="3" y1="10" x2="21" y2="10"></line>
                                        </svg>
                                    </div>
                                    <h3 className="font-bold text-gray-800 text-base">{t("TrainingSchedule") || "Training Schedule"}</h3>
                                    {remainingDays !== null && (
                                        <span className={`px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider shadow-sm ${
                                            remainingDays < 0 
                                                ? "bg-red-50 text-red-600 border border-red-100" 
                                                : remainingDays === 0 
                                                ? "bg-orange-50 text-orange-600 border border-orange-100 animate-pulse" 
                                                : remainingDays <= 3
                                                ? "bg-amber-50 text-amber-700 border border-amber-200"
                                                : "bg-blue-50 text-blue-600 border border-blue-100"
                                        }`}>
                                            {remainingDays < 0 
                                                ? t("Overdue") || "Overdue" 
                                                : remainingDays === 0 
                                                ? t("Today") || "Today" 
                                                : t("DaysLeft", { count: remainingDays })}
                                        </span>
                                    )}
                                </div>
                                {contextData?.user?.roles?.some((p) => p === "LegalResearchCoordinator") && (
                                    <button
                                        onClick={() => setIsTargetModalOpen(true)}
                                        className="p-1.5 hover:bg-gray-100 rounded-lg text-gray-400 hover:text-gray-600 transition-colors"
                                        title={t("EditSchedule") || "Edit Schedule"}
                                    >
                                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" fill="currentColor" />
                                        </svg>
                                    </button>
                                )}
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6">
                                {formState.logistics?.date && (
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 text-gray-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                                <line x1="3" y1="10" x2="21" y2="10"></line>
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">{t("Date") || "Date"}</p>
                                            <p className="text-sm font-semibold text-gray-700">{formatDate(formState.logistics.date)}</p>
                                        </div>
                                    </div>
                                )}
                                
                                {formState.logistics?.method && (
                                    <div className="flex items-start gap-3">
                                        <div className="mt-0.5 text-gray-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">{t("Method") || "Method"}</p>
                                            <p className="text-sm font-semibold text-gray-700">{getMethodDisplay(formState.logistics.method)}</p>
                                        </div>
                                    </div>
                                )}

                                {formState.logistics?.location && (
                                    <div className="flex items-start gap-3 col-span-full pt-1">
                                        <div className="mt-0.5 text-gray-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                                <circle cx="12" cy="10" r="3"></circle>
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">{t("Location") || "Location"}</p>
                                            <p className="text-sm font-semibold text-gray-700 leading-relaxed">{formState.logistics.location}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Documents */}
                    <div className="mt-6 space-y-4 border border-gray-400 p-4 mb-8 rounded-lg">
                        {formState?.directive_file &&
                            <>
                                <div className="flex items-center justify-between ">
                                    <FileView title={t("Directive") || "Directive"} file={formState?.directive_file} />
                                </div>
                            </>
                        }
                        {formState?.documents?.find((document: any) => document.document_type === "training_request_letter_file") &&
                            <>
                                {formState?.entry_registr &&
                                    <p className="text-[#432101AB] font-normal text-base">{t("RegisterNumber") || "Register Number"}: {formState.entry_registr}</p>
                                }
                                <p className="text-[#432101AB] font-normal text-base">{t("RequestLetterNumber") || "Request Letter Number"}: {formState?.request_letter_ref_no}</p>
                                <DocumentViewerModal
                                    documents={formState?.documents.filter((document: any) => document.document_type === "training_request_letter_file")}
                                    baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_research/legal-research-request-documents/document/`}
                                />
                            </>
                        }
                        <div className="mb-8">
                            <p className="text-[#432101AB] font-normal text-base">{t("TrainingTopicSummary") || "Training Topic Summary"}</p>
                            <p className="text-gray-500 font-medium mb-2">
                                {formState?.written_request_text}
                            </p>
                        </div>
                    </div>
                    
                    {contextData?.user?.user_type === "internal" && formState.summary &&
                        <div className="mt-6 space-y-4 border border-gray-400 p-4 mb-8 rounded-lg">
                            {formState?.documents?.filter((document: any) => document.document_type === "training_manual_file").length > 0 && (
                                <div>
                                    <p className="text-[#432101AB] font-normal text-base mb-4">{t("TrainingManual") || "Training Manual"}</p>
                                    {(() => {
                                        const trainingManualDocuments: any[] = formState?.documents.filter((document: any) => document.document_type === "training_manual_file").sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                                        const latestDocument = trainingManualDocuments[0];
                                        const previousDocuments = trainingManualDocuments.slice(1);
                                        
                                        return (
                                            <div>
                                                <div className="mb-4">
                                                    <p className="text-sm text-gray-600 mb-2">{t("LatestVersion") || "Latest Version"}</p>
                                                    <DocumentViewerModal
                                                        documents={[latestDocument]}
                                                        baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document`}
                                                    />
                                                </div>
                                                {previousDocuments.length > 0 && (
                                                    <div>
                                                        <details className="border border-gray-300 rounded-lg">
                                                            <summary className="p-3 cursor-pointer bg-gray-50 hover:bg-gray-100 rounded-lg">
                                                                <span className="font-medium">{t("PreviousVersions", { count: previousDocuments.length }) || `Previous Versions (${previousDocuments.length})`}</span>
                                                            </summary>
                                                            <div className="p-3 space-y-3">
                                                                {previousDocuments.map((doc: any, index: number) => (
                                                                    <div key={doc.document_uuid} className="border border-gray-200 rounded-lg p-2">
                                                                        <p className="text-xs text-gray-500 mb-1">
                                                                            {t("Version") || "Version"} {previousDocuments.length - index} - {new Date(doc.created_at).toLocaleDateString()}
                                                                        </p>
                                                                        <DocumentViewerModal
                                                                            documents={[doc]}
                                                                            baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document`}
                                                                            hideEmptyFile={true}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </details>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })()}
                                </div>
                            )}
                            <div className="mb-8">
                                <p className="text-[#432101AB] font-normal text-base">{t("TrainingManualSummary") || "Training Manual Summary"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.summary}
                                </p>
                            </div>
                            {/* Only team leaders (LegalResearchProsecutor with role === "leader") can upload training manual */}
                            {contextData?.user?.roles?.some((p) => p === "LegalResearchCoordinator") || 
                            (contextData?.user?.roles?.some((p) => p === "LegalResearchProsecutor") && 
                             formState?.prosecutor_assignments?.find((pa: any) => 
                               pa.prosecutor_id === contextData?.user?.user_id && pa.role === "leader"
                             )) ? (
                                <ShowUI
                                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.training_manual_approve.value}
                                    currentStatus={formState.status}
                                    forwardStatus={formState.forward_status}
                                >
                                    <div className="mb-4">
                                        <button
                                            type="button"
                                            className="flex items-center gap-2 px-4 py-2 rounded-md bg-[#E5E7EB] text-[#212121] font-medium hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                                            onClick={() => setIsModalOpen(true)}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" fill="currentColor" />
                                            </svg>
                                            {t("EditTrainingManual") || "Edit Training Manual"}
                                        </button>
                                    </div>
<LegislativeRespondBackForm
                             request={formState}
                             setLegalResearch={setFormState}
                             isOpen={isRespondBackFormOpen}
                             onClose={() => setIsRespondBackFormOpen(false)}
                             forward={LEGAL_TRAINING_PROVISION_REQUEST_STATUS.team_assigned.value}
                             forwardStatus={LEGAL_TRAINING_PROVISION_REQUEST_STATUS.assigned_to_prosecutor.value}
                             type="training"
                         />
                                    <div className="mt-4 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                                        <button
                                            type="button"
                                            className="flex-1 px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                            onClick={handleRespondBackClick}
                                        >
                                            {loading ? (
                                                <div className="flex items-center justify-center">
                                                    {LoadingIcon} {t("Submitting") || "Submitting..."}
                                                </div>
                                            ) : (
                                                t("RespondBack") || "Respond back"
                                            )}
                                        </button>
                                        <div
                                            onClick={() => { setConfirmationAction(LEGAL_TRAINING_PROVISION_REQUEST_STATUS.training_manual_approved.value); setIsConfirmationModalOpen(true); }}
                                            className="flex-1 text-center cursor-pointer px-6 py-3 rounded-md bg-[#212121] text-white font-semibold hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-600"
                                        >
                                            {loading ? (
                                                <div className="flex items-center justify-center">
                                                    {LoadingIcon} {t("Submitting") || "Submitting..."}
                                                </div>
                                            ) : (
                                                t("Approve") || "Approve"
                                            )}
                                        </div>
                                    </div>
                                    <UploadDraftLaw
                                        request={formState}
                                        setLegalResearch={setFormState}
                                        isOpen={isModalOpen}
                                        onClose={handleCloseModal}
                                        onUploadProposal={handleUploadProposalClick}
                                        type="training_manual"
                                    />
                                </ShowUI>
                            ) : null}
                        </div>
                    }
                    
                    {contextData?.user?.user_type === "internal" && formState?.outcome_of_training &&
                        <div className="mt-6 space-y-4 border border-gray-400 p-4 mb-8 rounded-lg">
                            {formState?.documents?.find((document: any) => document.document_type === "outcome_of_training_file") &&
                                <div>
                                    <p className="text-[#432101AB] font-normal text-base mb-4">{t("TrainingOutcome") || "Training Outcome"}</p>
                                    <DocumentViewerModal
                                        documents={formState?.documents.filter((document: any) => document.document_type === "outcome_of_training_file")}
                                        baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document`}
                                    />
                                </div>
                            }
                            <div className="mb-8">
                                <p className="text-[#432101AB] font-normal text-base">{t("TrainingOutcomeSummary") || "Training Outcome Summary"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.outcome_of_training}
                                </p>
                            </div>
                        </div>
                    }
                    
                    {contextData?.user?.user_type === "internal" && formState?.documents?.filter((document: any) => document.document_type === "training_feedback_file").length > 0 && (
                        <div className="mt-6 space-y-4 border border-gray-400 p-4 mb-8 rounded-lg">
                            <p className="text-[#432101AB] font-normal text-base mb-4">{t("TrainingFeedbackDocument") || "Training Feedback Document"}</p>
                            {(() => {
                                const trainingFeedbackDocuments: any[] = formState?.documents.filter((document: any) => document.document_type === "training_feedback_file").sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                                const latestDocument = trainingFeedbackDocuments[0];
                                const previousDocuments = trainingFeedbackDocuments.slice(1);
                                
                                return (
                                    <div>
                                        <div className="mb-4">
                                            <p className="text-sm text-gray-600 mb-2">{t("LatestVersion") || "Latest Version"}</p>
                                            <DocumentViewerModal
                                                documents={[latestDocument]}
                                                baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document`}
                                            />
                                        </div>
                                        {previousDocuments.length > 0 && (
                                            <div>
                                                <details className="border border-gray-300 rounded-lg">
                                                    <summary className="p-3 cursor-pointer bg-gray-50 hover:bg-gray-100 rounded-lg">
                                                        <span className="font-medium">{t("PreviousVersions", { count: previousDocuments.length }) || `Previous Versions (${previousDocuments.length})`}</span>
                                                    </summary>
                                                    <div className="p-3 space-y-3">
                                                        {previousDocuments.map((doc: any, index: number) => (
                                                            <div key={doc.document_uuid} className="border border-gray-200 rounded-lg p-2">
                                                                <p className="text-xs text-gray-500 mb-1">
                                                                    {t("Version") || "Version"} {previousDocuments.length - index} - {new Date(doc.created_at).toLocaleDateString()}
                                                                </p>
                                                                <DocumentViewerModal
                                                                    documents={[doc]}
                                                                    baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document`}
                                                                    hideEmptyFile={true}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </details>
                                            </div>
                                        )}
                                    </div>
                                );
                            })()}
                            <div className="mb-8">
                                <p className="text-[#432101AB] font-normal text-base">{t("TrainingFeedback") || "Training Feedback"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.feedback_from_trainee}
                                </p>
                            </div>
                        </div>
                    )}
                    
                    {formState?.distributed_zones?.length > 0 && (
                        <TabNav
                            active={activeTab}
                            tabs={formState.distributed_zones.map((zone: any) => ({ name: zone.admin_unit_name, submitted: !!zone.report_summary }))}
                            onSelect={setActiveTab}
                        />
                    )}
                    
                    {formState?.distributed_zones?.length > 0 && (() => {
                        const zoneFile = formState?.distributed_zones?.find((zone: any) => zone.admin_unit_name === activeTab);
                        const isReportSubmitted = !!zoneFile?.report_summary;
                        return (
                            <div className="mt-6 space-y-4 border border-gray-300 p-6 mb-8 rounded-xl bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 shadow-xl hover:shadow-2xl transition-shadow duration-300">
                                <div className="flex items-center justify-between mb-6">
                                    <h3 className="text-xl font-bold text-gray-900 flex items-center">
                                        <svg className="w-6 h-6 mr-3 text-red-800" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                        </svg>
                                        {t("TrainingReportFor", { zone: activeTab }) || `Training Report for ${activeTab}`}
                                    </h3>
                                    <div className={`flex items-center px-4 py-2 rounded-full text-sm font-semibold shadow-md ${isReportSubmitted ? 'bg-green-200 text-green-900 border border-green-300' : 'bg-red-200 text-red-900 border border-red-300'}`}>
                                        {isReportSubmitted ? (
                                            <>
                                                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                </svg>
                                                {t("Submitted") || "Submitted"}
                                            </>
                                        ) : (
                                            <>
                                                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                                </svg>
                                                {t("NotSubmitted") || "Not Submitted"}
                                            </>
                                        )}
                                    </div>
                                </div>
                                {formState?.directive_file &&
                                    <>
                                        <div className="flex items-center justify-between bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200">
                                            <FileView title={t("Directive") || "Directive"} file={formState?.directive_file} />
                                        </div>
                                    </>
                                }
                                {isReportSubmitted ? (
                                    <>
                                        <div className="bg-white p-5 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200">
                                            <p className="text-[#432101AB] font-semibold text-lg mb-3">{t("TrainingReportSummary") || "Training Report Summary"}</p>
                                            <p className="text-gray-800 font-medium leading-relaxed">
                                                {zoneFile?.report_summary}
                                            </p>
                                        </div>
{zoneFile?.documents?.find((document: any) => document.document_type === "distributed_training_zone_file") &&
                                             <div className="bg-white p-5 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200">
                                                 <DocumentViewerModal
                                                     documents={zoneFile?.documents.filter((document: any) => document.document_type === "distributed_training_zone_file")}
                                                     baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document/`}
                                                 />
                                             </div>
                                         }
                                         {zoneFile?.documents?.find((document: any) => document.document_type === "distributed_report_zone_file") &&
                                             <div className="bg-white p-5 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200">
                                                 {formState.request_letter_ref_no &&
                                                     <p className="text-[#432101AB] font-semibold text-lg mb-3">{t("RequestLetterNumber") || "Request Letter Number"}: {formState?.request_letter_ref_no}</p>}
                                                 <DocumentViewerModal
                                                     documents={zoneFile?.documents.filter((document: any) => document.document_type === "distributed_report_zone_file")}
                                                     baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document/`}
                                                 />
                                            </div>
                                        }
                                    </>
                                ) : (
                                    <div className="bg-gradient-to-br from-red-100 to-orange-100 p-8 rounded-lg shadow-lg text-center border-2 border-dashed border-red-400 hover:shadow-xl transition-shadow duration-300 animate-pulse">
                                        <svg className="w-20 h-20 mx-auto text-red-600 mb-6 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        <p className="text-red-800 text-2xl font-bold mb-3">{t("ReportNotSubmittedYet") || "Report Not Submitted Yet"}</p>
                                        <p className="text-red-600 text-lg">{t("TrainingReportNotUploadedMessage") || "The training report for this zone has not been uploaded. Please check back later or contact the relevant team."}</p>
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                    
                    {contextData?.user?.user_type === "internal" && formState?.prosecutor_assignments &&
                        formState?.prosecutor_assignments.length !== 0 &&
                        (<div className="mt-6 mb-2 flex bg-gray-50 rounded-lg border border-gray-200">
                            <ActionAvatars
                                title={t("TeamList") || "Team List"}
                                users={formState?.prosecutor_assignments}
                                prosecutor={true}
                            />
                            {(contextData?.user?.roles?.some((p) => p === "LegalResearchCoordinator") ||
                              contextData?.user?.roles?.some((p) => p === "LRDIFUDDirector")) && (
                                <svg onClick={() => setEditTeamModalOpen(true)} className="my-auto mr-2 hover:bg-gray-300 rounded-lg cursor-pointer" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                </svg>
                            )}
                            <svg onClick={() => setViewTeam(!viewTeam)} className="mr-2 ml-auto my-auto cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <mask id="mask0_9_31087" maskUnits="userSpaceOnUse" x="1" y="5" width="22" height="14">
                                    <path d="M12 18C17.523 18 22 12 22 12C22 12 17.523 6 12 6C6.477 6 2 12 2 12C2 12 6.477 18 12 18Z" fill="white" stroke="white" strokeWidth="1.33333" strokeLinejoin="round" />
                                    <path d="M12 14.5C12.663 14.5 13.2989 14.2366 13.7678 13.7678C14.2366 13.2989 14.5 12.663 14.5 12C14.5 11.337 14.2366 10.7011 13.7678 10.2322C13.2989 9.76339 12.663 9.5 12 9.5C11.337 9.5 10.7011 9.76339 10.2322 10.2322C9.76339 10.7011 9.5 11.337 9.5 12C9.5 12.663 9.76339 13.2989 10.2322 13.7678C10.7011 14.2366 11.337 14.5 12 14.5Z" fill="black" stroke="black" strokeWidth="1.33333" strokeLinejoin="round" />
                                </mask>
                                <g mask="url(#mask0_9_31087)">
                                    <path d="M0 0H24V24H0V0Z" fill="#EFC83D" />
                                </g>
                            </svg>
                        </div>)}
                    <br />
                    
                    {/* Additional Details */}
                    {formState.requested_by !== "internal" &&
                        contextData?.user?.user_type === "internal" &&
                        <>
                            <div>
                                <div className="flex">
                                    <p className="text-[#432101AB] font-normal text-base">{t("Stakeholder") || "Stakeholder"}</p>
                                    <p className="ml-auto text-[#0A1D39] font-semibold text-base">{formState?.organization_name}</p>
                                </div>
                                <hr className="w-full border-t-2 border-gray-300 my-4" />
                                <div className="flex">
                                    <p className="text-[#432101AB] font-normal text-base">{t("StakeholderType") || "Stakeholder Type"}</p>
                                    <p className="ml-auto text-[#0A1D39] font-semibold text-base">{formState?.organization_type}</p>
                                </div>
                                <hr className="w-full border-t-2 border-gray-300 my-4" />
                                <div className="flex">
                                    <p className="text-[#432101AB] font-normal text-base">{t("AppliedDate") || "Applied Date"}</p>
                                    <p className="ml-auto text-[#0A1D39] font-semibold text-base">{formatDate(formState?.created_at)}</p>
                                </div>
                                <hr className="w-full border-t-2 border-gray-300 my-4" />
                                <div className="flex">
                                    <p className="text-[#432101AB] font-normal text-base">{t("Address") || "Address"}</p>
                                    <p className="ml-auto text-[#0A1D39] font-semibold text-base">{formState?.organization_state}, {formState?.organization_zone}, {formState?.organization_kebele}</p>
                                </div>
                                <hr className="w-full border-t-2 border-gray-300 my-4" />
                                <div className="flex">
                                    <p className="text-[#432101AB] font-normal text-base">{t("Email") || "Email"}</p>
                                    <p className="ml-auto text-[#0A1D39] font-semibold text-base">{formState?.email_user_organization}</p>
                                </div>
                                <hr className="w-full border-t-2 border-gray-300 my-4" />
                            </div>
                            <br />
                        </>}

                    {/* Remark Section */}
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.internal_ui.value}
                        currentStatus={"all"}
                        forwardStatus={"all"}
                    >
                        {formState.remarks && formState?.remarks?.find((remark: any) => remark.role === "head") &&
                            <div>
                                <p className="text-[#432101AB] font-normal text-base">{t("RemarkForDirector") || "Remark For Director"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.remarks.filter((remark: any) => remark.role === "head").slice().reverse()[0]?.remark}
                                </p>
                                <br />
                            </div>
                        }
                        {formState.remarks && formState?.remarks?.find((remark: any) => remark.role === "director") &&
                            <div>
                                <p className="text-[#432101AB] font-normal text-base">{t("RemarkForCoordinator") || "Remark For Coordinator"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.remarks.filter((remark: any) => remark.role === "director").slice().reverse()[0]?.remark}
                                </p>
                                <br />
                            </div>
                        }
                        {formState.remarks && formState?.remarks?.find((remark: any) => remark.role === "coordinator") &&
                            <div>
                                <p className="text-[#432101AB] font-normal text-base">{t("RemarkForProsecutor") || "Remark For Prosecutor"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.remarks.filter((remark: any) => remark.role === "coordinator").slice().reverse()[0]?.remark}
                                </p>
                                <br />
                            </div>
                        }
                    </ShowUI>
                </div>
                
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.head_forward_to_director.value}
                    currentStatus={edit ? "all" : formState.status}
                    forwardStatus={edit ? "all" : formState.forward_status}
                >
                    <HeadRemark type="training" setEdit={setEdit} setFormState={setFormState} formState={formState} />
                </ShowUI>
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.director_forward_to_coordinator.value}
                    currentStatus={edit ? "all" : formState.status}
                    forwardStatus={edit ? "all" : formState.forward_status}
                >
                    <DirectorRemark type="training" setEdit={setEdit} setFormState={setFormState} formState={formState} />
                </ShowUI>
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_coordinator_forward_to_prosecutor.value}
                    currentStatus={edit ? "all" : formState.status}
                    forwardStatus={edit ? "all" : formState.forward_status}
                >
                    <CoordinatorRemark
                        type="training"
                        setEdit={setEdit}
                        setFormState={setFormState}
                        formState={formState}
                    />
                </ShowUI>
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.draft_and_additional_file.value}
                    currentStatus={"all"}
                    forwardStatus={formState.forward_status}
                >
                    <ProsecutorRemark setFormState={setFormState} formState={formState} />
                </ShowUI>
                
                <div className="mt-4 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                    {/* Schedule button only visible when training manual is approved */}
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.training_manual_approved.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div
                            onClick={() => setIsTargetModalOpen(true)}
                            className="flex-1 text-center cursor-pointer px-6 py-3 rounded-md bg-[#212121] text-white font-semibold hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-600"
                        >
                            {loading ? (
                                <div className="flex items-center justify-center">
                                    {LoadingIcon} {t("Submitting") || "Submitting..."}
                                </div>
                            ) : (
                                t("Schedule") || "Schedule"
                            )}
                        </div>
                    </ShowUI>

                    {(CanShow(LEGISLATIVE_DRAFTING_UI_RULES.distribute_to_zone.value, formState.status, formState.forward_status) ||
                        (contextData?.user?.roles?.some((role: string) => role === "LegalResearchCoordinator" || role === "LRDIFUDDirector") &&
                            CanShow(LEGISLATIVE_DRAFTING_UI_RULES.training_manual_approved.value, formState.status, formState.forward_status))) && (
                        <button
                            type="button"
                            className="flex-1 px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                            onClick={() => setIsDistributeModalOpen(true)}
                        >
                            {loading ? (
                                <div className="flex items-center justify-center">
                                    {LoadingIcon} {t("Submitting") || "Submitting..."}
                                </div>
                            ) : (
                                t("DistributeToZone") || "Distribute to Zone"
                            )}
                        </button>
                    )}
                </div>

                {/* Modal always available for editing existing schedule */}
                <ScheduleTitlePresentationModal
                    data={formState}
                    setLegalResearch={setFormState}
                    isOpen={isTargetModalOpen}
                    onClose={handleTargetCloseModal}
                    type="training"
                />
                
                <div className="flex gap-2 ml-auto">
                    {/* Only team leaders (LegalResearchProsecutor with role === "leader") can upload training outcome */}
                    {contextData?.user?.roles?.some((p) => p === "LegalResearchCoordinator") || 
                    (contextData?.user?.roles?.some((p) => p === "LegalResearchProsecutor") && 
                     formState?.prosecutor_assignments?.find((pa: any) => 
                       pa.prosecutor_id === contextData?.user?.user_id && pa.role === "leader"
                     )) ? (
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.training_schedule.value}
                            currentStatus={formState.status}
                            forwardStatus={formState.forward_status}
                        >
                            <div className="mt-4 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                                <button
                                    type="button"
                                    className="ml-auto px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                    onClick={() => setIsModalOpen(true)}
                                >
                                    {loading ? (
                                        <div className="flex items-center justify-center">
                                            {LoadingIcon} {t("Submitting") || "Submitting..."}
                                        </div>
                                    ) : (
                                        formState.training_outcome ? (t("ReUploadTrainingOutcome") || "ReUpload Training Outcome") : (t("UploadTrainingOutcome") || "Upload Training Outcome")
                                    )}
                                </button>
                            </div>
                            <UploadDraftLaw
                                request={formState}
                                setLegalResearch={setFormState}
                                isOpen={isModalOpen}
                                onClose={handleCloseModal}
                                onUploadProposal={handleUploadProposalClick}
                                type="training_outcome"
                            />
                        </ShowUI>
                    ) : null}
            {isDistributeModalOpen &&
                <DistributeToZone
                    setFormState={setFormState}
                    formState={formState}
                    setEdit={setIsDistributeModalOpen}
                />
            }
                    
                    {/* All LegalResearchProsecutor (team leaders and members) can upload training feedback */}
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.training_feedback.value}
                        currentStatus={formState.status}
                        forwardStatus={formState.forward_status}
                    >
                        <div className="mt-4 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                            <button
                                type="button"
                                className="ml-auto px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                onClick={() => setIsModalOpen(true)}
                            >
                                {loading ? (
                                    <div className="flex items-center justify-center">
                                        {LoadingIcon} {t("Submitting") || "Submitting..."}
                                    </div>
                                ) : (
                                    formState.status === LEGAL_TRAINING_PROVISION_REQUEST_STATUS.training_scheduled.value ? (t("ReUploadTrainingFeedback") || "ReUpload Training Feedback") : (t("UploadTrainingFeedback") || "Upload Training Feedback")
                                )}
                            </button>
                        </div>
                        <UploadDraftLaw
                            request={formState}
                            setLegalResearch={setFormState}
                            isOpen={isModalOpen}
                            onClose={handleCloseModal}
                            onUploadProposal={handleUploadProposalClick}
                            type="training_feedback"
                        />
                    </ShowUI>
                </div>
            </div>
            
            {/* Modals */}
            {publicFeedback &&
                (<PublicFeedback
                    data={formState}
                    setLegalResearch={setFormState}
                    isOpen={publicFeedback}
                    onClose={() => setPublicFeedback(false)}
                />)
            }
            {uploadAmend &&
                (<UploadAmendedFile
                    data={formState}
                    setLegalResearch={setFormState}
                    isOpen={uploadAmend}
                    onClose={() => setUploadAmend(false)}
                />)
            }
            {viewTeam &&
                <TeamView teamMembers={formState.prosecutor_assignments} onClose={() => setViewTeam(false)} />
            }
            {editTeamModalOpen && (
                <EditTeamModal
                    request={formState}
                    teamId={0}
                    isOpen={editTeamModalOpen}
                    onClose={() => setEditTeamModalOpen(false)}
                />
            )}
            {isConfirmationModalOpen && (
                <ConfirmationModal
                    isOpen={isConfirmationModalOpen}
                    isLoading={loading}
                    onCancel={() => setIsConfirmationModalOpen(false)}
                    onConfirm={() => {
                        if (confirmationAction === 'draft_approve') {
                            handleDraftApprove();
                        } else {
                            handleForward(confirmationAction);
                        }
                        setIsConfirmationModalOpen(false);
                    }}
                    title={t("ConfirmForward") || "Confirm Forward"}
                    message={t("ConfirmForwardMessage") || "Are you sure you want to forward this request? This action cannot be undone."}
                    confirmText={t("Forward") || "Forward"}
                    cancelText={t("Cancel") || "Cancel"}
                    type="warning"
                />
            )}
        </div>
    );
}

export default LegalTrainingProvisionDetail;